import React from "react";
import { Header } from "./Introduce";
import test_detail_style from "../css/test_detail_style.css";
import { Toast } from "antd-mobile";
import { request } from "../request";

class TestDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      active: 1,
      data: {
        file_name: "",
        content: "",
      },
    };
  }

  componentDidMount() {
    // console.log(this.props.match.params.id);
    request(
      "index/getOneDataFile",
      { type: "送样须知", id: this.props.match.params.id },
      ({ data }) => {
        if (data.code === 1) {
          console.log(data.data);
          this.setState({
            data: data.data,
          });
        } else {
          Toast.fail("获取设备失败");
        }
      }
    );
  }

  render() {
    return (
      <div>
        <Header text="技术资料"></Header>

        <div className={test_detail_style.title}>
          {this.state.data.file_name}
        </div>

        {/* <div className={test_detail_style.content}>
          {this.state.data.content}
        </div> */}
        {this.state.data.content.split("&").map((val, index) => (
          <div className={test_detail_style.content}>{val}</div>
        ))}
      </div>
    );
  }
}

export default TestDetail;



// WEBPACK FOOTER //
// ./src/pages/testDetail.js